<div class="image-holder profile-pic" [attr.data-test-id]="'image-' + dataTestId">
  <a
    data-test-id="avatar-link"
    [target]="openInNewWindow ? '_blank' : '_self'"
    [routerLink]="isLinkActive && link ? [link] : []"
    [ngClass]="{ 'inactive-link': !isLinkActive }"
  >
    <img
      [attr.data-test-id]="dataTestId"
      [src]="image"
      default="{{ DEFAULT_PROFILE_IMAGE }}"
      [width]="width"
      [height]="height"
      [class]="class"
      [ngStyle]="{
        'min-width.px': width,
        'max-width.px': width
      }"
      alt="image description"
      onContextMenu="return false;"
    />

    <span
      [ngStyle]="{
        'font-size': fontSize
      }"
      data-test-id="disabled-badge"
      *ngIf="isShowDeactivatedBadge"
      class="badge bg-secondary deactivated-label"
      >{{ 'DEACTIVATED_HINT' | translate }}</span
    >
  </a>
</div>
